export const getOltLabel = client => client.olt || (client.oltId ? `OLT ${client.oltId}` : 'OLT não informada');

export const getCtoFromClientName = name => {
    const match = name?.match(/^(?:T\d+\s+)?CTO\s+(?:T\d+\s+)?([A-Z0-9]+(?:[./][A-Z0-9]+)*)(?:\s+([A-Z]\d+[A-Z]\d+(?:[./]\d+)*))?(?=\s|-|$)/i);
    return match ? `CTO ${match[1].toUpperCase()}${match[2] ? ` ${match[2].toUpperCase()}` : ''}` : null;
};
export const getCtoLabel = client => client.cto || getCtoFromClientName(client.name) || (client.ctoId ? `CTO ${client.ctoId}` : 'CTO não informada');

// A CTO belongs to an OLT. Use its stable ID when available, including when OLT names repeat.
export const getCtoGroupKey = client => JSON.stringify([
    client.oltId ? ['id', String(client.oltId)] : ['name', client.olt || null],
    client.cto || getCtoFromClientName(client.name) || (client.ctoId ? ['id', String(client.ctoId)] : null),
]);

export function groupMonitoringClients(clients) {
    const groups = new Map();
    clients.forEach(client => {
        const key = getCtoGroupKey(client);
        if (!groups.has(key)) {
            groups.set(key, { key, olt: getOltLabel(client), oltId: client.oltId, cto: getCtoLabel(client), clients: [] });
        }
        groups.get(key).clients.push(client);
    });
    return [...groups.values()].sort((a, b) =>
        a.olt.localeCompare(b.olt, 'pt-BR', { numeric: true }) ||
        String(a.oltId || '').localeCompare(String(b.oltId || ''), 'pt-BR', { numeric: true }) ||
        a.cto.localeCompare(b.cto, 'pt-BR', { numeric: true })
    );
}
